;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { FormFeedback, Input, Label } from 'reactstrap';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

interface FormikInputProps {
  type: string;
  name: string;
  formik: any;
  intlKey?: string;
  id?: string;
  required?: boolean;
  className?: string;
  withoutLabel?: boolean;
  dictionary: Partial<Dictionaries>;
}

function FormikInput(props: FormikInputProps): JSX.Element {
  const { className, dictionary, type, name, id, required, intlKey, formik, withoutLabel } = props;
  const { formatMessage } = getI18nUtils(dictionary);
  const { touched, error } = formik.getFieldMeta(name);

  return (
    <div className={className || ''}>
      {!withoutLabel && (
        <Label for={name} className={required ? 'required' : ''}>
          {formatMessage({ id: intlKey || name })}
        </Label>
      )}
      <Input invalid={!!(touched && error)} type={type} name={name} id={id || name} {...formik.getFieldProps(`${name}`)} />
      {error && <FormFeedback>{formatMessage({ id: error })}</FormFeedback>}
    </div>
  );
}

export default FormikInput;
